<div class="tpl3pl-page-container">
	<p class="text-muted mb-2 small">Get quantities from the 3PL and sync them here. Send an Inbound order first if the 3PL has no inventory yet. <a routerLink="../inbound">Inbound</a></p>
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters">
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2 inventory-warehouse-field">
				<mat-label matTooltip="Mapped ERP location code (loccode). Use the code shown in the Warehouse column below.">Warehouse</mat-label>
				<input matInput [(ngModel)]="selectedWarehouse" placeholder="Leave empty for all">
			</mat-form-field>
		</div>
		<div class="tpl3pl-toolbar-actions">
			<button mat-raised-button color="primary" (click)="onRefresh()">
				<mat-icon>refresh</mat-icon> Refresh
			</button>
			<button mat-raised-button color="accent" (click)="syncInventory()" [disabled]="syncing">
				<mat-icon>sync</mat-icon> {{ syncing ? 'Pulling...' : 'Pull Inventory from PGS' }}
			</button>
			<button mat-stroked-button (click)="openManualSyncRaw()" [disabled]="manualSyncRawLoading" matTooltip="Open raw request/response view; send manually to see what we send and what they return">
				<mat-spinner *ngIf="manualSyncRawLoading" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!manualSyncRawLoading">code</mat-icon>
				Manual sync (raw)
			</button>
			<button mat-stroked-button color="warn" (click)="clearSyncedInventory()" [disabled]="clearing" matTooltip="Remove all cached 3PL inventory from this system (use after 3PL cleared their side)">
				<mat-spinner *ngIf="clearing" diameter="20"></mat-spinner>
				<mat-icon *ngIf="!clearing">delete_sweep</mat-icon>
				Clear synced inventory
			</button>
		</div>
	</div>

	<div *ngIf="inventoryStatus" class="mb-4">
		<div class="row">
			<div class="col-md-2">
				<div class="card text-center" matTooltip="Items at 3PL (from last pull).">
					<div class="card-body py-3">
						<div class="text-muted small">3PL Inventory</div>
						<div class="h4 mb-0">{{ inventoryStatus.total_items || 0 }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-2">
				<div class="card text-center" matTooltip="Pulled items with sync status synced.">
					<div class="card-body py-3">
						<div class="text-muted small">Synced</div>
						<div class="h4 mb-0 text-success">{{ inventoryStatus.synced_items || 0 }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-2">
				<div class="card text-center" matTooltip="Pulled items with sync status pending.">
					<div class="card-body py-3">
						<div class="text-muted small">Pending</div>
						<div class="h4 mb-0 text-warning">{{ inventoryStatus.pending_items || 0 }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-2">
				<div class="card text-center" matTooltip="Pulled items with sync status error.">
					<div class="card-body py-3">
						<div class="text-muted small">Errors</div>
						<div class="h4 mb-0 text-danger">{{ inventoryStatus.error_items || 0 }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-2">
				<div class="card text-center" matTooltip="Last time we pulled from 3PL.">
					<div class="card-body py-3">
						<div class="text-muted small">Last Sync</div>
						<div class="small mb-0">{{ (inventoryStatus.last_sync_time || inventoryStatus.last_sync) ? ((inventoryStatus.last_sync_time || inventoryStatus.last_sync) | date:'short') : 'Never' }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="loading" class="text-center p-4">
		<mat-spinner diameter="40"></mat-spinner>
	</div>

	<!-- Items at 3PL (collapsed by default, searchable inline) -->
	<div class="mb-4">
		<mat-expansion-panel [expanded]="false" class="inventory-items-panel">
			<mat-expansion-panel-header>
				<mat-panel-title>
					<strong>Items at 3PL</strong>
					<span *ngIf="inventoryListTotal > 0" class="small text-muted ml-2">({{ inventoryListTotal | number }} total)</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<div *ngIf="inventoryListLoading" class="text-center py-3">
				<mat-spinner diameter="32"></mat-spinner>
			</div>
			<p *ngIf="!inventoryListLoading && inventoryItems.length === 0 && inventoryListTotal === 0" class="text-muted small mb-0">No items. Pull inventory from PGS or adjust filters.</p>
			<ng-container *ngIf="!inventoryListLoading && inventoryItems.length > 0">
				<div class="d-flex flex-wrap align-items-center gap-2 mb-3">
					<mat-form-field appearance="fill" class="tpl3pl-field inventory-items-search" style="min-width: 200px;">
						<mat-label>Search SKU, warehouse, status</mat-label>
						<input matInput [ngModel]="itemListSearch" (ngModelChange)="onInventorySearchInput($event)" placeholder="Type to filter...">
						<mat-icon matSuffix>search</mat-icon>
					</mat-form-field>
					<mat-form-field appearance="fill" class="tpl3pl-field inventory-status-filter" style="min-width: 140px;">
						<mat-label>Status</mat-label>
						<mat-select [(ngModel)]="inventoryStatusFilter" (selectionChange)="onStatusFilterChange()">
							<mat-option value="">All</mat-option>
							<mat-option value="synced">Synced</mat-option>
							<mat-option value="pending">Pending</mat-option>
							<mat-option value="error">Error</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="table-responsive">
					<table class="table table-sm table-bordered">
						<thead>
							<tr>
								<th class="sortable" (click)="setSort('stockid')"><span>SKU</span><mat-icon class="sort-icon">{{ sortIcon('stockid') }}</mat-icon></th>
							<th class="sortable" (click)="setSort('warehouse_code')"><span>Warehouse</span><mat-icon class="sort-icon">{{ sortIcon('warehouse_code') }}</mat-icon></th>
								<th>PGS Warehouse</th>
							<th class="sortable" (click)="setSort('internal_qoh')" matTooltip="Quantity on hand in your internal system for the mapped warehouse location"><span>Internal QOH</span><mat-icon class="sort-icon">{{ sortIcon('internal_qoh') }}</mat-icon></th>
								<th class="sortable" (click)="setSort('quantity_on_hand')" matTooltip="Quantity on hand reported by 3PL"><span>3PL On Hand</span><mat-icon class="sort-icon">{{ sortIcon('quantity_on_hand') }}</mat-icon></th>
								<th class="sortable" (click)="setSort('quantity_available')" matTooltip="Quantity available for new orders at 3PL"><span>3PL Available</span><mat-icon class="sort-icon">{{ sortIcon('quantity_available') }}</mat-icon></th>
								<th class="sortable" (click)="setSort('sync_status')"><span>Status</span><mat-icon class="sort-icon">{{ sortIcon('sync_status') }}</mat-icon></th>
							</tr>
						</thead>
						<tbody>
						<ng-container *ngFor="let row of inventoryItems">
						<tr>
							<td>{{ row.stockid }}</td>
							<td>{{ row.warehouse_code }}</td>
							<td class="small text-muted">{{ row.pgs_warehouse || '-' }}</td>
							<td [ngClass]="{'text-danger': row.internal_qoh < row.quantity_available, 'text-warning': row.internal_qoh === 0}">
								{{ row.internal_qoh }}
							</td>
							<td>{{ row.quantity_on_hand }}</td>
							<td>{{ row.quantity_available }}</td>
							<td><span [ngClass]="{'text-success': row.sync_status === 'synced', 'text-warning': row.sync_status === 'pending', 'text-danger': row.sync_status === 'error'}">{{ row.sync_status }}</span></td>
						</tr>
						<tr *ngIf="row.lots && row.lots.length > 0" class="lot-detail-row">
							<td [attr.colspan]="8" class="p-0">
								<div class="lot-details px-3 py-1">
									<table class="table table-sm table-borderless mb-0 small">
										<thead>
											<tr class="text-muted">
												<th>Lot</th>
												<th>Qty</th>
												<th>Expiration</th>
												<th>Status</th>
											</tr>
										</thead>
										<tbody>
											<tr *ngFor="let lot of row.lots">
												<td>{{ lot.lot_number }}</td>
												<td>{{ lot.quantity }}</td>
												<td>{{ lot.expiration_date ? (lot.expiration_date | date:'shortDate') : '-' }}</td>
												<td>{{ lot.lot_status || 'available' }}</td>
											</tr>
										</tbody>
									</table>
								</div>
							</td>
						</tr>
						</ng-container>
						</tbody>
					</table>
				</div>
				<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-2">
					<span class="small text-muted" *ngIf="inventoryListTotal > 0">Showing {{ inventoryPageIndex * inventoryPageSize + 1 }}–{{ pageDisplayEnd }} of {{ inventoryListTotal | number }}</span>
					<mat-paginator
						*ngIf="inventoryListTotal > 0"
						[length]="inventoryListTotal"
						[pageSize]="inventoryPageSize"
						[pageIndex]="inventoryPageIndex"
						[pageSizeOptions]="inventoryPageSizeOptions"
						(page)="onInventoryPage($event)"
						showFirstLastButtons
						class="inventory-items-paginator">
					</mat-paginator>
				</div>
			</ng-container>
		</mat-expansion-panel>
	</div>

	<!-- Inventory Sync Result -->
	<div *ngIf="lastSyncResult" class="mb-3">
		<div class="card" [ngClass]="{'border-success': lastSyncResult.success && lastSyncResult.errors === 0, 'border-danger': !lastSyncResult.success, 'border-warning': lastSyncResult.success && lastSyncResult.errors > 0}">
			<div class="card-body py-3">
				<strong>{{ lastSyncResult.success ? (lastSyncResult.errors > 0 ? 'Inventory sync completed with errors' : 'Inventory sync complete') : 'Sync failed' }}:</strong> {{ lastSyncResult.message }}
				<span *ngIf="lastSyncResult.success && lastSyncResult.synced !== undefined"> — {{ lastSyncResult.synced }} synced, {{ lastSyncResult.errors || 0 }} errors</span>
				<div *ngIf="(lastSyncResult.response || lastSyncResult.diagnostic) && (!lastSyncResult.success || (lastSyncResult.synced === 0))" class="mt-2">
					<details>
						<summary class="small">{{ lastSyncResult.diagnostic ? 'Why 0 items? Diagnostic & response' : 'API response' }}</summary>
						<div *ngIf="lastSyncResult.diagnostic" class="mb-2">
							<pre class="mb-0 p-2 bg-light small" style="max-height: 120px; overflow: auto;">{{ lastSyncResult.diagnostic | json }}</pre>
						</div>
						<pre *ngIf="lastSyncResult.response" class="mb-0 p-2 bg-light small mt-1" style="max-height: 200px; overflow: auto;">{{ lastSyncResult.response | json }}</pre>
					</details>
				</div>
			</div>
		</div>
	</div>
</div>
